const SIGNAL_PREFIX = 'atlas-succession-carry-complete';
const RECENT_SIGNAL_MS = 5 * 60 * 1000;

export function successionCarrySignalKey(folderId: string, diagramId: string): string {
  return `${SIGNAL_PREFIX}:${folderId}:${diagramId}`;
}

/** Notify another same-origin chart tab that protected draft replay has settled. */
export function publishSuccessionCarryComplete(folderId: string, diagramId: string): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(successionCarrySignalKey(folderId, diagramId), String(Date.now()));
  } catch {
    // Storage can be unavailable in private/restricted browser contexts. The
    // target's normal projection refresh remains the fallback.
  }
}

/**
 * Subscribe to cross-tab completion and catch a signal published just before
 * this tab mounted. Returning the unsubscribe keeps the projection hook pure.
 */
export function subscribeToSuccessionCarryComplete(
  folderId: string,
  diagramId: string,
  onComplete: () => void,
): () => void {
  if (typeof window === 'undefined') return () => undefined;
  const key = successionCarrySignalKey(folderId, diagramId);
  const onStorage = (event: StorageEvent) => {
    if (event.key === key && event.newValue) onComplete();
  };
  window.addEventListener('storage', onStorage);
  try {
    const publishedAt = Number(window.localStorage.getItem(key));
    if (Number.isFinite(publishedAt) && Date.now() - publishedAt <= RECENT_SIGNAL_MS) {
      queueMicrotask(onComplete);
    }
  } catch {
    // See publish fallback above.
  }
  return () => window.removeEventListener('storage', onStorage);
}
